var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("नियम एवं शर्तें"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("सामान्य नियम"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " हमारी वेबसाइट केवल कानूनी आयु के व्यक्तियों के लिए प्रतिबंधित है, जैसा कि उस क्षेत्राधिकार में निर्धारित किया गया है जिसमें व्यक्ति रहता है। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " हमारी वेबसाइट के उपयोग करने वाले किसी भी उपयोगकर्ता द्वारा उपयोग किए गए किसी भी राष्ट्रीय कानून, संघीय कानून या अंतर्राष्ट्रीय कानून के लिए हमारी वेबसाइट कोई जिम्मेदारी नहीं रखती। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " उपयोगकर्ता अपने स्वयं की क्रिया के लिए जिम्मेदार हैं, और अपने देश के कानूनों (जिसमें राज्य के कानून या कानूनी मुद्दे) के अधीन हैं। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " सभी एजेंट अपने-अपने सदस्यों के खाते के लिए जिम्मेदार हैं, तथा जमा किए गए सभी पुष्टि किए गए दांव का सम्मान करना होगा। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " एजेंट हमारी वेबसाइट के भागीदार नहीं हैं। इसलिए, हमारी वेबसाइट खिलाड़ियों और एजेंटों के बीच किसी भी अंतर या विवाद के लिए जिम्मेदार नहीं है। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " उपयोगकर्ता नाम और पासवर्ड की गोपनीयता उपयोगकर्ता की जिम्मेदारी है। यदि उपयोगकर्ता का उपयोगकर्ता नाम और पासवर्ड चोरी हो जाता है या लीक हो जाता है, तो उपयोगकर्ता को तुरंत अपने एजेंट से संपर्क करना चाहिए। एजेंट उपयोगकर्ता का उपयोगकर्ता नाम और पासवर्ड बदल देगा। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " यदि उपयोगकर्ता नाम और पासवर्ड चोरी हो जाते हैं, तो उपयोगकर्ता अपने खाते के लिए जिम्मेदार होगा और प्रस्तुत सभी पुष्टि दांव का सम्मान करेगा। "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("गेमिंग नियम"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "हमारी वेबसाइट द्वारा तय किए गए खेल परिणाम अंतिम और बाध्यकारी होंगे।"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " विवाद के सभी मामलों में, हमारी वेबसाइट के प्रबंधन और खिलाड़ी दोनों को इस बात पर सहमत होना होगा कि हमारी वेबसाइट का लेनदेन लॉग विवाद का अंतिम निर्णायक होगा। सभी विवादों को परिणाम तय होने के दिन तक दर्ज किया जाना चाहिए। मैच के बाद के दिन, कोई दावा स्वीकार नहीं किया जाएगा। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "खिलाड़ी अपने खाते के सभी लेनदेन की सटीकता की जांच के लिए स्वयं जिम्मेदार हैं।"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " दांव लगाने से पहले आपको यह सुनिश्चित करना चाहिए कि आपके दांव में कोई गलती, त्रुटि या चूक नहीं है। एक बार कंप्यूटर द्वारा दांव स्वीकार कर लिया गया तो उसे बदला या रद्द नहीं किया जा सकता। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " हम किसी भी ऐसे खाते को फ्रीज या रद्द करने का अधिकार रखते हैं जो इन नियमों का उल्लंघन करता है, धोखाधड़ी में शामिल है, अनधिकृत गतिविधि, हमला, हैकिंग, जालसाजी, मानक नियमों को नुकसान पहुंचाने, या सिंडिकेट बेटिंग में शामिल है। ऐसे सभी खातों की शेष राशि जब्त कर ली जाएगी, बिना किसी पूर्व सूचना के। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " हम किसी भी ऐसे दांव या बेटिंग टिकट को अमान्य या रद्द करने का अधिकार सुरक्षित रखते हैं, जो सिंडिकेट बेटिंग, समन्वित बेटिंग, मिलीभगत, धोखाधड़ी, सिस्टम के दुरुपयोग, तकनीकी त्रुटियों या गलत ऑड्स का लाभ उठाने, या अनुचित लाभ प्राप्त करने के किसी अन्य प्रयास से संबंधित पाया जाता है। इससे संबंधित किसी भी जीत की राशि को वापस लिया जा सकता है, और संबंधित खाते को निलंबित या बंद किया जा सकता है। "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("सीमाएँ और दायित्व"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " पूर्वनिर्धारित की व्याख्या पर प्रतिकूल प्रभाव डाले बिना, हमारी वेबसाइट किसी भी व्यक्ति के लिए किसी भी तोड़फोड़, अप्रत्याशित घटना, आग, बाढ़, विस्फोट, बिजली कटौती, संचार विफलता, या किसी अन्य तकनीकी समस्या के कारण किसी भी देरी, नुकसान, त्रुटि या किसी भी अन्य होने वाली घटना के लिए उत्तरदायी नहीं होगी। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " हमारी वेबसाइट किसी प्राकृतिक आपदा, बाढ़, आग, नागरिक अशांति, आतंकवादी गतिविधि, सरकारी आदेश या प्रतिबंध के लिए जिम्मेदार नहीं होगी। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " नेटवर्क कनेक्शन, संचार, सिस्टम या मानव त्रुटियों के कारण होने वाली किसी भी बेटिंग समस्या के मामलों में, जैसे दोहरी बेटिंग, बेट कन्फ़र्म न होना, या गेम शुरू होने के बाद बेट लगना — ऐसे मामलों में हम स्थिति के अनुसार कार्रवाई करेंगे, और किसी भी प्रकार की देनदारी नहीं लेंगे। यदि यह त्रुटि दोबारा होती है और आप बिना रिपोर्ट किए बेट लगाते रहते हैं, तो सभी जीत/हार के लिए आप जिम्मेदार होंगे। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " ये नियम और विनियम दोनों पक्षों के बीच पूर्ण समझौते का गठन करते हैं। "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                " यदि इन नियमों के अंग्रेज़ी संस्करण और किसी अन्य भाषा संस्करण के बीच कोई अंतर मौजूद है, तो अंग्रेज़ी संस्करण को सही और मान्य माना जाएगा। "
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }